module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "patientDownloads"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "weekTags"
    }
  }, [_c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'resources'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelResources'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('resources')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'mealplans'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelMealPlans'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('mealplans')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'seasonal'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelSeasonalDownloads'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('seasonal')
      }
    }
  }), _vm._v(" "), _vm._l((_vm.lessons), function(item, index) {
    return _c('span', {
      key: 'week-list-' + index,
      staticClass: "tag",
      class: {
        'disabled': item.status.locked,
        'active': _vm.selectedFilter === item.course_id
      },
      domProps: {
        "textContent": _vm._s(item.week_name.replace('Week', _vm.$t('message.labelWeek')))
      },
      on: {
        "click": function($event) {
          return _vm.updateFilter(item.course_id, item.status.locked)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "id": "weekLists"
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "hintText": "Resources"
    },
    on: {
      "change": _vm.updateFilter
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelResources'),
      "value": "resources"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelMealPlans'),
      "value": "mealplans"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelSeasonalDownloads'),
      "value": "seasonal"
    }
  }), _vm._v(" "), _vm._l((_vm.lessons), function(item, index) {
    return _c('mu-menu-item', {
      key: 'week-list-' + index,
      attrs: {
        "value": item.course_id,
        "title": _vm.$t('message.labelDownloadsFrom') + ' ' + item.week_name.replace('Week', _vm.$t('message.labelWeek')),
        "disabled": item.status.locked
      }
    })
  })], 2)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "downloadTabs"
    }
  }, [_c('mu-row', _vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('mu-col', {
      key: 'download-tab-' + tabIndex,
      attrs: {
        "tablet": "50",
        "desktop": "50",
        "width": "50"
      }
    }, [_c('a', {
      staticClass: "tab",
      class: {
        'active': _vm.activeTab === tab.key
      },
      domProps: {
        "textContent": _vm._s(tab.label)
      },
      on: {
        "click": function($event) {
          return _vm.setTab(tab.key)
        }
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading || _vm.showFilterLoader) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading || !_vm.showFilterLoader) ? _c('div', {
    staticClass: "container"
  }, [(_vm.activeTab === 'grid') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.items), function(res, index) {
    return _c('mu-col', {
      key: 'download-item-' + index,
      staticClass: "download-item",
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "33"
      }
    }, [_c('mu-card', {
      staticClass: "grid-item card-background-cover bottom",
      attrs: {
        "align": "center"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(res)
        }
      }
    }, [_vm._o(_c('img', {
      attrs: {
        "src": res.image_url,
        "width": "100%"
      }
    }), 0, 'download-item-' + index), _vm._v(" "), _vm._o(_c('mu-card-header', {
      attrs: {
        "title": res.title,
        "subTitle": res.description
      }
    }), 1, 'download-item-' + index), _vm._v(" "), _c('mu-card-actions', {
      staticClass: "actions"
    }, [_c('mu-flat-button', {
      attrs: {
        "primary": "",
        "icon": "file_download",
        "disabled": !_vm.$store.state.status.payment.paid,
        "label": res.button_text
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'list') ? _c('mu-card', {
    staticClass: "listViewSpacer"
  }, [_c('mu-list', _vm._l((_vm.items), function(res, index) {
    return _c('div', {
      key: 'download-item-' + index,
      staticClass: "download-item"
    }, [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": res.title,
        "describeText": res.description
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(res)
        }
      }
    }, [_c('mu-flat-button', {
      attrs: {
        "slot": "right",
        "primary": "",
        "icon": "file_download",
        "disabled": !_vm.$store.state.status.payment.paid,
        "label": res.button_text
      },
      slot: "right"
    })], 1), _vm._v(" "), (_vm.items.length !== index + 1) ? _c('mu-divider') : _vm._e()], 1)
  }), 0)], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac9c628","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Downloads/PatientDownloads.vue
// module id = 3765
// module chunks = 1